import React, { Component } from 'react'

import { get } from '../../api'
import capitalize from '../../capitalize'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditCategories extends Component {

    state = {
        selected: this.props.categories.map(category => category.id)
    }

    componentDidMount() {
        this.fetchCategories()
    }

    fetchCategories = async () => {
        try {
            const categories = await get('/categories')
            this.setState({ categories })
        } catch (err) {
            alert(err.message)
        }
    }

    onSave = () => {
        this.props.onSave({
            categories: this.state.selected.join(', ')
        })
    }

    toggle = (id, isSelected ) => {
        if (isSelected) {
            this.setState({
                selected: this.state.selected.concat(id)
            })
        } else {
            this.setState({
                selected: this.state.selected.filter(item => item !== id)
            })
        }
    }

    render() {
        const { selected = [], categories = [] } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditCategories"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Categories">
            <Form>
                <div>
                    {categories.map(category => {
                        return (
                            <div key={category.id}>
                                <input
                                    type="checkbox"
                                    checked={selected.includes(category.id)}
                                    onChange={e => this.toggle( category.id, e.target.checked )} />
                                    {capitalize(category.name)}
                            </div>
                        )
                    })}
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditCategories



// WEBPACK FOOTER //
// ./src/components/LBUs/EditCategories.js